module.exports = __webpack_public_path__ + "img/leadsHold.ae5c3182.svg";